import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  setReportType,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} = getReportActions();

const setCarrierGuid = createAction('setCarrierGuid');
const getReportDataRequest = createAction('getReportDataRequest');

export {
  // report
  setReports,
  setReportType,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  // report
  setCarrierGuid,
  getReportDataRequest,
};
